export const convertToJson = (properties, requiredFields) => {
    return {
        required: requiredFields,
        type: "object",
        properties: Object.fromEntries(
            Object.entries(properties).map(([key, value]) => [
                key,
                {
                    type: value.type,
                    // description: value.description || ""
                }
            ])
        )
    };
};

export const convertArrayToJson = (parameters) => {
    const requiredFields = parameters
        .filter(param => param.required)
        .map(param => param.name);

    const properties = parameters.reduce((acc, param) => {
        acc[param.name] = {
            type: param.schema?.type || "string", // Default to string if type is missing
            // description: param.description || ""
        };
        return acc;
    }, {});
    
    return {
        required: requiredFields,
        type: "object",
        properties
    };
};

//Method to copy text to clipboard
export const copyToClipboard = (text, setCopiedCallback) => {
    navigator.clipboard.writeText(text)
        .then(() => {
            setCopiedCallback(true);
            setTimeout(() => setCopiedCallback(false), 2000);
        })
        .catch((err) => {
            console.error("Failed to copy text to clipboard:", err);
        });
};

